import { useMutation } from "@apollo/client";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";

import { UPDATE_VISIT } from "../visit.queries";
import { parseParams } from "../../../helpers/clean-object";

import { UpdateVisitInput } from "../../../__generated__/globalTypes";
import {
  UpdateVisitMutation,
  UpdateVisitMutationVariables,
} from "../../../__generated__/UpdateVisitMutation";

interface IProps {
  id: number;
  onCompleted: () => any;
}

export const useUpdateVisit = ({ id, onCompleted }: IProps) => {
  const form = useForm<UpdateVisitInput>({
    mode: "all",
  });
  const [mutate, { loading }] = useMutation<
    UpdateVisitMutation,
    UpdateVisitMutationVariables
  >(UPDATE_VISIT, {
    refetchQueries: "active",
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          id,
          input: parseParams(input),
        },
      });

      if (data?.updateVisit?.ok) {
        onCompleted();
      } else {
        throw Error(data?.updateVisit?.error ?? "Error");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };

  return {
    form,
    mutate,
    loading,
    submit,
  };
};
